/** PostHog US Cloud ingest host — same across all environments today. */
export const POSTHOG_HOST = 'https://us.i.posthog.com';

/**
 * PDP layout and gallery test. Must match PDP_LAYOUT_REVAMP_FLAG in
 * joystagram's PDP/usePDPLayoutRevampTestVariant.js.
 */
export const PDP_LAYOUT_REVAMP_FLAG = 'pdp-layout-revamp';
